module.exports = __webpack_public_path__ + "static/caltech.e2e3880e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/caltech.png
// module id = 2180
// module chunks = 61762850755587